// https://stackoverflow.com/questions/66469497/gltf-setting-colors-basecolorfactor

export default {
	'orange': [
		0.6800203421720954,
		0.2271365255051489,
		0.030256518852388652,
		1
	],
	'yellow': [
		0.9528999924659729,
		0.28619998693466187,
		0,
		1
	],
	'blue': [
		0.028991186547107816,
		0.215764399609395,
		0.5417983559501369,
		1
	],
	'green': [
		0.000023328004666098932,
		0.1904628788224093,
		0.2195197180748679,
		1
	],
	'lavender': [
		0.09868919754109445,
		0.1011451642095999,
		0.348864834082879,
		1
	]
}
